import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class FooterContainer extends ThemeComponent {
    @Ref({ required: false }) columntoggle!: HTMLButtonElement[];

    init() {

        // Handle column toggle
        this.handleColumnToggle();
    }

    handleColumnToggle() {
        for (const elem of this.columntoggle) {
            this.$listen(elem, 'click', () => {
                elem.closest('.footer__navigation-column')?.classList.toggle('footer__navigation-column--active');
            });
        }
    }
}
